'use strict';

import BiBaseDataItem from './bi-base-item';

/**
 * Represents the "app version" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/18
 *
 * It should indicate an app of a certain version has run
 */
export default class BiAppVersionDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(18, sessionId);
  }
}



// WEBPACK FOOTER //
// ./data-items/bi-app-version-item.js